<template>
    <div class="connections-widget">
        <common-widget>
            <common-widget-header :heading="$t('elements.home.connections.heading')"></common-widget-header>

            <common-widget-content>
                <div class="connections-widget__checkbox">
                    <checkbox-input
                        color="secondary"
                        :label="$t('elements.home.connections.physicians')"
                        :value="getPhysicians"
                        @change="filterPhysiciansChange()"
                    ></checkbox-input>
                    <checkbox-input
                        color="primary"
                        :label="$t('elements.home.connections.ancillary')"
                        :value="getAncillaries"
                        @change="filterAncillariesChange()"
                    ></checkbox-input>
                </div>
                <div v-if="totalCount > 0" class="connections-widget__count">
                    <p>
                        {{ totalCount }}
                    </p>
                </div>

                <div v-if="totalCount === 0" class="connections-widget__no-connections-info">
                    <p>{{ $t('elements.home.connections.new_members') }}</p>
                    <p>{{ $t('elements.home.connections.in_geographic_area') }}</p>
                    <p>{{ $t('elements.home.connections.will_appear') }}</p>
                </div>

                <ul v-else class="connections-widget__list">
                    <li v-for="(user, index) in newMembersInArea" :key="index" class="connections-widget__item">
                        <article class="connections-item" @click="openSearchAndAddMembersModal(user)">
                            <div class="connections-item__avatar">
                                <common-user-avatar
                                    :user="user"
                                    size="member-switch"
                                    :isUserProfileLinkEnabled="false"
                                ></common-user-avatar>

                                <div class="connections-widget__item-type"></div>
                            </div>

                            <h4 class="connections-item__name">
                                <common-user-name :user="user"></common-user-name>
                            </h4>

                            <p class="connections-item__role">
                                {{ user.name || user.practice.name }}
                            </p>
                        </article>
                    </li>
                </ul>

                <button
                    v-if="!$auth.isUserPracticeOther()"
                    type="button"
                    class="connections-widget__more"
                    @click="showAllClicked"
                >
                    {{ $t('elements.home.connections.show_all') }}
                </button>
            </common-widget-content>
        </common-widget>

        <search-and-add-members-modal
            v-if="isSearchAndAddMembersModalOpen"
            :prefillUser="selectedUser"
            :isOpen="isSearchAndAddMembersModalOpen"
            @close="closeSearchAndAddMembersModal"
        ></search-and-add-members-modal>
        <paywall-modal v-if="isPaywallModalOpen" @close="isPaywallModalOpen = false"></paywall-modal>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    import UsersAPI from 'api/UsersAPI'
    import ConnectionMixin from 'mixins/ConnectionMixin'
    import CheckboxInput from 'components/form-inputs/CheckboxInput'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import SearchAndAddMembersModal from 'components/page-elements/network/SearchAndAddMembersModal'
    import PaywallModal from 'components/page-elements/PaywallModal'

    dayjs.extend(utc)

    export default {
        mixins: [ConnectionMixin],

        components: { CheckboxInput, SearchAndAddMembersModal, PaywallModal },

        data() {
            return {
                users: [],
                totalCount: 0,
                selectedUser: null,
                isSearchAndAddMembersModalOpen: false,
                windowWidth: window.innerWidth,
                getPhysicians: true,
                getAncillaries: true,
                PracticeTypeEnum: PracticeTypeEnum,
                isPaywallModalOpen: false,
            }
        },

        computed: {
            newMembersInArea() {
                return this.windowWidth > 1366 ? this.users : [this.users[0]]
            },
        },

        methods: {
            getMembersNearby() {
                if (this.$auth.getPractice().id) {
                    UsersAPI.getMembersNearby(this.$auth.getActiveMember().id, {
                        limit: 3,
                        getPhysicians: this.getPhysicians ? 1 : 0,
                        getAncillaries: this.getAncillaries ? 1 : 0,
                    }).then((res) => {
                        this.users = res
                        this.totalCount = res._headers['x-total-count'] || 0
                    })
                }
            },

            filterPhysiciansChange() {
                this.getPhysicians = !this.getPhysicians
                this.getMembersNearby()
            },

            filterAncillariesChange() {
                this.getAncillaries = !this.getAncillaries
                this.getMembersNearby()
            },

            showAllClicked() {
                if (this.$auth.isUserPracticeDemo()) {
                    this.openPaywallModal()
                    return
                }
                this.$router.push({ name: 'index.members.nearby' })
            },

            togglePaywallModal() {
                this.isPaywallModalOpen = !this.isPaywallModalOpen
            },

            openPaywallModal() {
                this.togglePaywallModal()
            },

            closeSearchAndAddMembersModal() {
                this.isSearchAndAddMembersModalOpen = false
            },

            openSearchAndAddMembersModal(user) {
                this.selectedUser = user
                this.isSearchAndAddMembersModalOpen = true
            },
            calculateWindowWidth() {
                this.windowWidth = window.innerWidth
            },
        },

        mounted() {
            this.getMembersNearby()
            window.addEventListener('resize', this.calculateWindowWidth)
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.calculateWindowWidth)
        },
    }
</script>
